import type { ParseResult } from './types';
import { WebSocketError } from './WebSocketError';

export function parseInputSupportMessage<T>(raw: unknown): ParseResult<T> {
  const msg = raw as { result_code: number; error_message: string };
  if (msg.result_code !== 0) {
    return {
      ok: false,
      error: new WebSocketError(msg.error_message || `エラーコード: ${msg.result_code}`, 'SERVER_ERROR', 0),
    };
  }
  return { ok: true, data: raw as T };
}
